import React, { Fragment, useState } from 'react';
import * as UI from './styles';
import chevronUp from '../../assets/icons/chevron_up.svg';
import chevronDown from '../../assets/icons/chevron_down.svg';
import { useHistory } from "react-router-dom";
import { IconComponent } from '../Icon';


interface IMenuItem {
  icon: number;
  label: string;
  isAccordion?: boolean;
  isSoon?: boolean;
  submenus?: {
    label: string;
    link?: string;
    isSoon?: boolean;
  }[];
  handle?(): void;
  subMenuHandle?(): void;
  link?: string;
  className?: string;
  subMenuClassName?: string;
  subMenuBefore?: React.ReactNode;
}

function MenuItem({ icon, label, isAccordion, submenus, handle, subMenuHandle, link, isSoon, className, subMenuClassName, subMenuBefore }: IMenuItem) {
  const [isOpen, setIsOpen] = useState(false);

  const { push } = useHistory();

  return (
    <Fragment>
      <UI.Item
        className={className}
        title={label}
        onClick={() => {
          if (handle)
            handle();
          if (isAccordion) {
            setIsOpen(!isOpen);
          } else {
            push(`${link}`);
          }
        }}
      >
        {/* <img src={icon} alt={`Icone ${label}`} /> */}
        <IconComponent type={icon} style={{ color: '#5D5D5D' }} />
        {isAccordion ? (
          <span>{label}</span>
        ) : (
          <div onClick={() => push(`${link}`)} >
            <span>{label}</span>
          </div>
        )}
        {isSoon && <span className='isSoon'>Em Breve</span>}
        {isAccordion && (
          <img
            src={isOpen ? chevronDown : chevronUp}
            alt="Chevron Icone"
            id="chevron"
          />
        )}
      </UI.Item>

      {isAccordion && isOpen && submenus && (
        <UI.ItemBody>
          <ul className={subMenuClassName}>
            {submenus.map((sb, index) => (
              <li key={index} title={sb.label} onClick={() => {
                if (subMenuHandle)
                  subMenuHandle();
                push(sb.link ?? '/')
              }} >
                {subMenuBefore}
                {sb.label}
                {sb.isSoon && <span className='isSoon'>Em Breve</span>}
              </li>
            ))}
          </ul>
        </UI.ItemBody>
      )}
    </Fragment>
  );
}

export default MenuItem;
